/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgQuestionCircle = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 2.5a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM8 11a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm0-6a2 2 0 0 1 2 2c0 .73-.212 1.14-.754 1.708l-.264.27C8.605 9.37 8.5 9.582 8.5 10a.5.5 0 0 1-1 0c0-.73.212-1.14.754-1.708l.264-.27C8.895 7.63 9 7.418 9 7a1 1 0 0 0-2 0 .5.5 0 0 1-1 0 2 2 0 0 1 2-2Z",
        fill: "gray"
    }));
export default SvgQuestionCircle;
